import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';
import { Evaluation } from '@app/models';

@Injectable({ providedIn: 'root' })
export class EvaluationService {
  constructor(private httpClient: HttpClient) { }

  // toutes les evaluations
  getEvaluationsToManage() {
    return this.httpClient.get<any>(`${environment.apiEndPoint}evaluations/read_manage`)
        .pipe(
            map(res => res ? res.document.records as Evaluation[] : []),
            catchError(this.handleError)
        );
  }

  private handleError(error: any): Promise<any> {
    let retour = error?.error?.message || error?.message || error;
    if(error?.error?.data) retour += '<br />'+error?.error?.data;
    return Promise.reject(retour);
  }
}